var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initCommentCard = /* @__PURE__ */ __name(($el, $refs, commentId) => {
  const random_id = utils.shortUUID();
  const comment = _comments[commentId] || utils.JSONParse(document.querySelector(`[data-comment-data="${commentId}"]`)?.innerHTML);
  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...comment ?? {},
    url: comment?.url
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicText,
    getContentLabels
  };
}, "initCommentCard");
const hydrateCommentCard = /* @__PURE__ */ __name(($el, card_handle, comment_id, classes = []) => {
  const hydrateCommentCardContent = /* @__PURE__ */ __name(() => {
    const node = document.querySelector(`[data-comment-card='${card_handle}']`)?.cloneNode(true);
    if (!node && !$el.hasAttribute("data-intersected")) {
      $el.setAttribute("data-intersected", "true");
      const mo = new MutationObserver((mutation, obs) => {
        if ($el.hasAttribute("data-cards-loaded")) {
          $el.removeAttribute("data-intersected");
          const node2 = document.querySelector(`[data-comment-card='${card_handle}']`)?.cloneNode(true);
          if (node2 && $el && $el.parentNode) {
            node2?.removeAttribute(`data-comment-card`);
            node2?.setAttribute("data-comment-id", comment_id);
            node2.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
              el.remove();
            });
            node2.classList.add(...classes);
            $el.parentNode.replaceChild(node2, $el);
          }
          mo.disconnect();
          observer.disconnect();
        }
      });
      mo.observe($el, { attributes: true });
      return;
    }
    if (node && $el && $el.parentNode) {
      node?.removeAttribute(`data-comment-card`);
      node?.setAttribute("data-comment-id", comment_id);
      node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
        el.remove();
      });
      node.classList.add(...classes);
      $el.parentNode.replaceChild(node, $el);
    }
  }, "hydrateCommentCardContent");
  if ($el.hasAttribute("data-intersected")) {
    hydrateCommentCardContent();
    return;
  }
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        hydrateCommentCardContent();
        observer.disconnect();
      }
    },
    { rootMargin: "300px 300px 300px 300px" }
  );
  observer.observe($el);
}, "hydrateCommentCard");
window._sections["initCommentCard"] = initCommentCard;
window._sections["hydrateCommentCard"] = hydrateCommentCard;
